import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";

import { authenticatedRoute } from "../_authenticated.js";

const tasksSearchSchema = z.object({
  view: z.enum(["table", "board"]).optional().catch(undefined),
});

export const tasksRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/tasks",
  validateSearch: (search: Record<string, unknown>) => tasksSearchSchema.parse(search),
  component: lazyRouteComponent(() => import("./tasks.page.js"), "TasksPage"),
});
